module.exports = __webpack_public_path__ + "img/second_top_bg.48ed4a82.png";